var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptySeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.331 20.595H9.114v-2.227c2.633 0 6.886-.608 6.886-2.634v-2.23c0-.81-.608-1.417-1.823-1.822.81-2.027 1.823-5.874 1.013-7.9C13.975.95 8.506.95 7.899.95 7.292.95 2.027.95.81 3.785c-.81 1.823.203 5.671 1.013 7.9C.608 12.088 0 12.695 0 13.504v2.227c0 2.027 4.25 2.634 6.886 2.634v2.227H5.671c-2.633 0-3.645 0-4.455.81a1.839 1.839 0 0 0-.608 1.418.957.957 0 0 0 1.012 1.015.957.957 0 0 0 1.013-1.013 11.583 11.583 0 0 1 2.835-.203h4.456c.95-.049 1.902.02 2.835.203a1.085 1.085 0 0 0 1.013 1.013.957.957 0 0 0 1.013-1.013 2.188 2.188 0 0 0-.607-1.418c-.203-.607-1.216-.81-3.847-.81Zm-7.496-16c.405-.81 3.038-1.417 5.266-1.417s4.861.607 5.266 1.417c.404 1.215-.81 5.063-1.215 6.278a27.441 27.441 0 0 0-4.051-.405c-1.359.024-2.714.16-4.05.405-.406-.404-1.823-4.86-1.216-6.278Zm6.076 11.748h-.81c-4.86 0-6.074-.811-6.074-.811v-1.823s1.823-.607 5.873-.607c4.05 0 5.873.81 5.873.81v1.62c-.256.16-.527.295-.81.404-1.331.28-2.69.416-4.05.405l-.002.002Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySeat);
export default __webpack_public_path__ + "static/media/empty-seat.063636b73fe9ca6d2a57fbad02109400.svg";
export { ForwardRef as ReactComponent };